import React from 'react';
import { string, number } from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';

export const ProductSetPlaceholder = ({ type, height }) => {
  return (
    <div data-component="ProductSetPlaceholder">
      <Placeholder type={type} height={`${height}px`} />;
    </div>
  );
};

ProductSetPlaceholder.propTypes = {
  type: string,
  height: number
};

ProductSetPlaceholder.defaultProps = {
  type: 'rect',
  height: 0
};
